import SVGIcon from '../SVGIcon';

function IncorrectIcon() {
  return (
    <SVGIcon width="22" height="22" viewBox="0 0 26 26" fill="none">
      <circle cx="12" cy="12" r="12" fill="#ffff" />
      <path d="M8 8 L16 16 M16 8 L8 16" stroke="#757575" strokeWidth="2" strokeLinecap="round" />
    </SVGIcon>
  );
}

export default IncorrectIcon;
